<template>
  <div class="mydemand">
    <div class="page-title">
      <div class="page-nav-items">
        <span class="page-parentname" @click="Back">项目管理></span>
        <span>{{ $route.query.name }}我的未完成BUG清单</span>
      </div>
    </div>
    <div class="table-header-box cell-row">
      <div class="cell-column demand-index-cell">序号</div>
      <div class="cell-column demand-project-name">项目名称</div>
      <div class="cell-column demandtype-cell">角色端口/页面</div>
      <div class="cell-column demand-publishtime-cell">问题描述</div>
      <div class="cell-column projecttype-cell">提报时间</div>
      <div class="cell-column demand-status-cell">状态</div>
      <div class="cell-column operate-cell">操作</div>
    </div>
    <div
      class="table-list-box"
      v-infinite-scroll="loadMoreData"
      :infinite-scroll-disabled="disabledLoadMore"
    >
      <template v-if="bugList.length">
        <div
          v-for="(item, index) in bugList"
          :key="index"
          class="datalist-row cell-row"
        >
          <div class="cell-column demand-index-cell">
            {{ index + 1 }}
          </div>
          <div class="cell-column demand-project-name">
            {{ item.save_data_001[0].mid_table_remark_001 }}
          </div>
          <div class="cell-column demandtype-cell">
            {{ item.mid_table_remark_002 + "/" + item.mid_table_remark_010 }}
          </div>
          <div class="cell-column demand-publishtime-cell">
            {{ item.mid_table_remark_013 }}
          </div>
          <div class="cell-column projecttype-cell">
            {{ item.time_insert }}
          </div>
          <div class="cell-column demand-status-cell">
            {{ item.mid_table_remark_008 == 0 ? "未完成" : "已完成" }}
          </div>
          <div class="cell-column operate-cell">
            <div @click="toBugDetail('edit', item)">查看/编辑</div>
            <div
              v-if="userInfo.id_public_user_info == item.id_public_user_info"
              :class="item.mid_table_remark_008 == 1 ? 'diabled' : ''"
              @click="TraceRecords(item, index)"
            >
              跟踪
            </div>
            <div
              v-if="userInfo.id_public_user_info == item.id_public_user_info"
              @click="handleDelBug(item, index)"
            >
              删除
            </div>
          </div>
        </div>

        <el-dialog
          title="测试跟踪"
          :before-close="handCancel"
          :visible.sync="dialogFormVisible"
        >
          <div class="dialog-content">
            <el-form>
              <el-form-item
                :rules="rules.region"
                label="该bug是否完成修改"
                label-width="150px"
              >
                <el-select
                  v-model="form.region"
                  placeholder="请选择是否完成修改"
                  popper-class="customselect-popper"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in stateOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 已完成 -->
              <el-form-item
                v-if="form.region == 1"
                prop="mid_table_remark_007"
                label="备注："
              >
                <template>
                  <el-input
                    class="custom-input txt-normalstyle"
                    placeholder="bug修复备注"
                    v-model="form.mid_table_remark_007"
                  >
                  </el-input>
                </template>
              </el-form-item>
              <!-- 未完成 -->
              <el-form-item
                v-if="form.region == 0"
                prop="mid_table_remark_002"
                label="备注："
              >
                <template>
                  <el-input
                    class="custom-input txt-normalstyle"
                    placeholder="bug未修复成功备注"
                    v-model="form.mid_table_remark_002"
                  >
                  </el-input>
                </template>
              </el-form-item>
              <el-form-item
                v-if="form.region == 0"
                prop="mid_table_remark_012"
                label="上传视频："
              >
                <template>
                  <UploadVideo
                    ref="goodsVideo"
                    :limit="1"
                    @imagesData="getVideoData"
                  ></UploadVideo>
                </template>
              </el-form-item>
              <el-form-item
                v-if="form.region == 0"
                prop="mid_table_remark_006"
                label="上传图片："
              >
                <template>
                  <UploadImages
                    ref="goodsDescImage"
                    :keyWord="'goodsDescImage'"
                    :limit="3"
                    @imagesData="getImageFile"
                  ></UploadImages>
                </template>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handCancel" class="btn-e0e0e0">取 消</el-button>
            <el-button class="btn-determine" @click="submitBug(form)"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </template>
      <NoneData v-else></NoneData>
    </div>
    <DialogFeedbackList ref="dialogFeedbackList"></DialogFeedbackList>
  </div>
</template>
<script>
import UploadImages from "@/components/UploadImages/UploadImages";
import UploadVideo from "@/components/UploadVideo/UploadVideo";
import storage from "@/utils/customLocalStorage";
import NoneData from "@/components/NoneData";
import CustomSelect from "@/components/CustomSelect.vue";
import DialogFeedbackList from "@/components/dialog/FeedbackList";
import {
  demandTypeOptions,
  demandProjectTypeOptions,
} from "@/assets/js/dictionary";
import { checkDataFromDictionary, formatDate } from "@/utils/tool";
import lodash from "lodash";
import pageCommon from "@/utils/pagecommon";
import demandApi from "@/api/demand";
import bugApi from "@/api/bug";
export default {
  name: "BUGList",
  components: {
    CustomSelect,
    DialogFeedbackList,
    NoneData,
    UploadImages,
    UploadVideo,
  },
  created() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 1);

    _this.currentPage = 1;
    _this.total = 1;
    _this.demandList = [];
    _this.isRequesting = true;
    _this.disabledLoadMore = false;
    _this.form.region = _this.stateOptions[0].value;
  },
  data() {
    return {
      demandTypeList: demandTypeOptions,
      demandProjectTypeList: demandProjectTypeOptions,
      demandList: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      disabledLoadMore: false,
      isRequesting: false,
      bugList: [],
      projectId: "",
      dialogFormVisible: false,
      form: {
        region: "",
        mid_table_remark_007: "", //1001的备注
        mid_table_remark_002: "", //2002的备注
        mid_table_remark_006: "", //2002的图例
        mid_table_remark_012: "", //2002的视频
        id: "",
      },
      stateOptions: [
        { label: "已完成", value: "1" },
        { label: "未完成", value: "0" },
      ],
      rules: {
        region: [
          {
            required: true,
            message: "请确认该bug是否修改完成",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  mounted: function () {
    let _this = this;
    _this.getBugList();
  },
  filters: {
    showLocalDictionaryVal: function (val, list, checkprop, resultprop) {
      return checkDataFromDictionary(`${val}`, list, checkprop, resultprop);
    },
    showTime: function (val) {
      if (!val) {
        return;
      }
      let time = formatDate(
        new Date(val.replace(/-/g, "/")),
        "YYYY.MM.DD hh:mm:ss"
      );
      return time;
    },
  },
  methods: {
    showOperateName: function () {
      let _this = this;
      if (_this.operateName === "detail") {
        return "BUG清单详情";
      }
      if (_this.operateName === "edit") {
        return "查看&编辑";
      }
    },
    Back: function () {
      let _this = this;
      _this.$router.go(-1);
    },
    getBugList: function () {
      let _this = this;
      let requestData = {
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        isloading: true,
        is_online: 0,
        id_public_user_info: this.userInfo.id_public_user_info,
        mid_table_remark_008: 0,
      };
      pageCommon.apiRequestCommon(bugApi, "getList", requestData).then(
        (res) => {
          let bugList = res.page_content;
          if (bugList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          // 用concat
          _this.bugList.push(...bugList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          _this.isRequesting = false;
          _this.bugList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    TraceRecords: function (item) {
      let _this = this;
      _this.dialogFormVisible = true;
      _this.form.id = item.id_public_middle_table;
    },
    // dialog取消关闭
    handCancel() {
      let _this = this;
      _this.$message("已取消跟踪");
      _this.dialogFormVisible = false;
      _this.form = {
        region: "",
        mid_table_remark_007: "", //1001的备注
        mid_table_remark_002: "", //2002的备注
        mid_table_remark_006: "", //2002的图例
        mid_table_remark_012: "", //2002的视频
        id: "",
      };
      _this.form.region = _this.stateOptions[0].value;
    },
    // 跟踪或完成bug修改
    submitBug: function (form) {
      let _this = this;
      let time = new Date();
      // 已完成
      if (form.region == 1) {
        let page_content = {
          mid_table_remark_007: form.mid_table_remark_007,
          mid_table_remark_008: form.region,
          mid_table_remark_012: form.mid_table_remark_012,
          isloading: true,
          mid_table_remark_011: formatDate(time, "YYYY.MM.DD hh:mm:ss"),
        };
        if (form.id) {
          page_content["id_public_middle_table"] = form.id;
        }

        pageCommon.apiRequestCommon(bugApi, "createBug", page_content).then(
          (res) => {
            _this.isRequesting = false;
            _this.$message.success("BUG修复完成！");
            _this.dialogFormVisible = false;
            _this.bugList.forEach((item, index) => {
              if (item.id_public_middle_table == form.id) {
                _this.bugList.splice(index, 1);
              }
            });
            // dialog关闭之后的操作，清空数据，恢复原样
            _this.form = {
              region: "",
              mid_table_remark_007: "", //1001的备注
              mid_table_remark_002: "", //2002的备注
              mid_table_remark_006: "", //2002的图例
              mid_table_remark_012: "", //2002的视频
              id: "",
            };
            _this.form.region = _this.stateOptions[0].value;
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
        // 未完成
      } else if (form.region == 0) {
        let page_content = {
          mid_table_remark_009: _this.userInfo.nick_name,
          id_public_user_info: _this.userInfo.id_public_user_info,
          mid_table_remark_002: form.mid_table_remark_002,
          mid_table_remark_006: form.mid_table_remark_006,
          mid_table_remark_012: form.mid_table_remark_012,
          mid_table_remark_001: _this.projectId,
          mid_table_remark_010: form.id,
          type_inner_app: 2002,
          is_online: 0,
          isloading: true,
        };
        pageCommon.apiRequestCommon(bugApi, "createBug", page_content).then(
          (res) => {
            _this.isRequesting = false;
            _this.$message.success("跟踪记录添加成功，请在BUG详情中查看！");
            _this.dialogFormVisible = false;
            // dialog关闭之后的操作，清空数据，恢复原样
            _this.form = {
              region: "",
              mid_table_remark_007: "", //1001的备注
              mid_table_remark_002: "", //2002的备注
              mid_table_remark_006: "", //2002的图例
              mid_table_remark_012: "", //2002的视频
              id: "",
            };
            _this.form.region = _this.stateOptions[0].value;
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
      } else {
        _this.$message.error("系统异常，请稍后刷新重试！");
      }
    },
    loadMoreData: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      _this.currentPage += 1;
    },
    // 加载BUG清单数据
    toBugDetail: function (type, item) {
      let _this = this;
      let id = item ? item.id_public_middle_table : "";
      _this.$router.push({
        path: "/BUGDetail",
        query: {
          id: id,
          o: type,
          projectId: _this.projectId,
        },
      });
    },
    /*
     * 获取视频文件
     * */
    getVideoData(data) {
      let _this = this;
      data.length
        ? (_this.form.mid_table_remark_012 = data[0].image_url)
        : (_this.form.mid_table_remark_012 = "-1");
    },
    /*
     * 获取图片文件
     * */
    getImageFile(data, type) {
      let _this = this;

      if (data.length) {
        let newImageData = [];
        data.forEach((item) => {
          newImageData.push(item.image_url);
        });
        _this.form.mid_table_remark_006 = newImageData.join(",");
      } else {
        _this.form.mid_table_remark_006 = "-1";
      }
    },
    // 删除 is_online设置为111
    handleDelBug: function (item, index) {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;

      let page_content = {
        id_public_middle_table: item.id_public_middle_table,
        isloading: true,
      };
      pageCommon.apiRequestCommon(bugApi, "delBug", page_content).then(
        (res) => {
          _this.isRequesting = false;
          _this.$message.success("删除项目成功");
          _this.bugList.splice(index, 1);
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.mydemand {
  .btn-determine {
    background: #ffdcdc;
    color: #ec4040;
    border: 1px solid #ffdcdc;
  }
  position: relative;
  width: 100%;
  // height: 100%;
  height: 1131px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .process-createbtn-box {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      .process-box {
        position: relative;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;

        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ec4040;
        line-height: 16px;
        cursor: pointer;
        .icon-process {
          position: relative;
          width: 17px;
          height: 14px;
          margin-right: 6px;
        }
      }
      .btn-create {
        width: 90px;
        height: 36px;
        line-height: 36px;

        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        margin-left: 40px;
      }
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
    // margin-right: 20px;
  }

  .page-nav-items {
    .page-parentname {
      color: rgba(153, 153, 153, 1);
      cursor: pointer;
    }
  }

  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .demandtype-cell {
    position: relative;
    width: 150px;
    text-align: left;
  }
  .projecttype-cell {
    position: relative;
    width: 150px;
    text-align: center;
  }
  .project-yusuan-cell {
    position: relative;
    width: 180px;
    text-align: center;
    margin-left: 10px;
  }
  .demand-index-cell {
    position: relative;
    width: 30px;
    text-align: center;
    &.colblue {
      color: #0072ff;
    }
  }
  .demand-project-name {
    position: relative;
    width: 130px;
    text-align: center;
    &.colblue {
      color: #0072ff;
    }
  }
  .demand-status-cell {
    position: relative;
    width: 50px;
    text-align: center;
    &.colblue {
      color: #0072ff;
    }
  }
  .demand-publishtime-cell {
    position: relative;
    width: 225px;
    text-align: left;
  }

  .operate-cell {
    position: relative;
    width: 220px;
    text-align: center;
  }
  .table-header-box {
    position: relative;

    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 35px;
    margin-bottom: 24px;
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;
    &:nth-child(2n) {
      background: #f6f6f6;
    }
    &:last-child {
      margin-bottom: 0;
    }

    .cell-column {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      &.colblue {
        color: #0072ff;
      }
    }
    .operate-cell {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;

      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 16px;
      div {
        cursor: pointer;
      }
      .diabled {
        pointer-events: none;
        color: #ffa8a8;
        cursor: auto;
      }
    }
    .demand-publishtime-cell {
      text-align: left;
    }
    .projecttype-cell,
    .project-yusuan-cell,
    .demand-status-cell {
      text-align: center;
    }

    .white-cell {
      text-align: center;
    }
  }
}
.dialog-content {
  .el-select {
    display: block;
    width: 150px;
    margin-left: 24px;
    /deep/ .el-select-dropdown__item.selected {
      color: #ec4040;
    }

    /deep/ .el-select .el-input__inner:focus {
      border-color: #07060b;
    }
  }
  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #07060b;
  }
}
</style>
